import { render, staticRenderFns } from "./CruiseDetailPage.vue?vue&type=template&id=df3b4f68&scoped=true&"
import script from "./CruiseDetailPage.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b4f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df3b4f68')) {
      api.createRecord('df3b4f68', component.options)
    } else {
      api.reload('df3b4f68', component.options)
    }
    module.hot.accept("./CruiseDetailPage.vue?vue&type=template&id=df3b4f68&scoped=true&", function () {
      api.rerender('df3b4f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/CruiseDetailPage.vue"
export default component.exports